import { render, staticRenderFns } from "./Nutbody.vue?vue&type=template&id=39e2f324&scoped=true&"
import script from "./Nutbody.vue?vue&type=script&lang=js&"
export * from "./Nutbody.vue?vue&type=script&lang=js&"
import style0 from "./Nutbody.vue?vue&type=style&index=0&id=39e2f324&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e2f324",
  null
  
)

export default component.exports